module.exports = __webpack_public_path__ + "media/message 2.47198c45.mp3";